import React from 'react';

import { useMediaQuery }  from "react-responsive";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import HeaderNavbar from "components/Navbar/HeaderNavbar";
import FooterNavbar from "components/Navbar/FooterNavbar";
import MainTheme from "components/MainTheme/MainTheme";
import MainThemeMobile from "components/MainTheme/MainThemeMobile";

// sections for this page
import SectionMainContents from "./Sections/SectionMainContents";
import SectionImage from "./Sections/SectionImage";

import blogPostsPageStyle from "assets/jss/trip-kit/views/blogPostsPageStyle.js";
import SectionAppDown from './Sections/SectionAppDown';

const useStyles = makeStyles(blogPostsPageStyle);

const MainPage = (props) => {
  
  const classes = useStyles();
  const isPc = useMediaQuery({
    query : "(min-width: 768px)"
  })
  const isMobile = useMediaQuery({
    query : "(max-width: 767px)"
  })

  return (
    <>
      <HeaderNavbar {...props}/>
      {isPc && <MainTheme {...props}/>}
      {isMobile && <MainThemeMobile {...props}/>}
      <div className={classes.main}>
          {/* <SectionAppDown />*/}
          <SectionMainContents {...props} />
          <SectionImage {...props}/>
      </div>
      
      <FooterNavbar />
    </>
  );
};

export default MainPage;
